import EStatusAPIKeys from 'types/backend_models/lookup_status/EStatusAPIKeys';
import IStatusModel from 'types/backend_models/lookup_status/IStatusModel';
import { parseResponse } from '../resCheck';
import { setFetchStatusPending, setFetchStatusSucces, setFetchStatusError } from 'redux/reducers/data_action_reducers/lookup_status/statusDataReducer';
import { AppDispatch } from 'redux/store';
import { AppThunk } from 'redux/reducers/rootReducer';
import { getDataActionConstants } from '../dataActionConstants';

/** fetch statusdata dynamically from api */
export function fetchStatus(statusAPIKey: EStatusAPIKeys): AppThunk
{
	return (dispatch: AppDispatch) =>
	{
		const constants = getDataActionConstants();
		const requestInit: RequestInit = {
			headers: constants.headers
		}

		dispatch(setFetchStatusPending({ statusKey: statusAPIKey }))
		fetch(`${constants.serverRoot}/api/${statusAPIKey}`, requestInit)
			.then((response: Response) => parseResponse<IStatusModel[]>(response))
			.then(response =>
			{
				if (response.ok) {
					// cast to correct data type
					let data = response.json as IStatusModel[];
					dispatch(setFetchStatusSucces({
						statusKey: statusAPIKey,
						data: data
					}));
				} else {
					throw new Error(response.error);
				}
			})
			.catch((error: Error) =>
			{
				console.error(error.message);
				dispatch(setFetchStatusError({
					statusKey: statusAPIKey,
					error: error.message
				}));
			})
	}
}